import React from 'react'

import './PaymentOptions.scss'

function renderCreditCard() {
    return null
}

function renderDebit(props) {
    return (
        <div>
            <label className="label-grid label-grid--small">
                <span className="label-text">IBAN</span>
                <div className="label-control">
                    <input 
                        className="input" 
                        type="text" 
                        name="iban" 
                        pattern="^([A-Z]{2})([0-9]{2})([A-Z0-9]{9,30})$" 
                        value={props.paymentOption.iban} 
                        onChange={(e) => props.onChange({
                            ...props.paymentOption,
                            [e.target.name]: e.target.value.replace(/[^A-Z0-9]+/gi,'').toUpperCase(),
                        })} />
                </div>
            </label>
            <label className="label-grid label-grid--small">
                <span className="label-text">BIC</span>
                <div className="label-control">
                    <input 
                        className="input" 
                        type="text" 
                        name="bic" 
                        value={props.paymentOption.bic} 
                        onChange={(e) => props.onChange({
                            ...props.paymentOption,
                            [e.target.name]: e.target.value.replace(/[^A-Z0-9]+/gi,'').toUpperCase(),
                        })} />
                </div>
            </label>    
        </div>
    )
}

const availablePaymentOptions = {
    paypal: {
        title: 'PayPal'
    },
    // paydirekt: {
    //     title: 'Paydirekt'
    // },
    debit: {
        title: 'Lastschrift',
        render: renderDebit
    },
    giropay: {
        title: 'GiroPay',
        render: renderDebit
    },
    sofort: {
        title: 'Klarna'
    }
}

export default function PaymentOptions(props) {
    const selectedPaymentOption = availablePaymentOptions[props.paymentOption && props.paymentOption.value]

    return <div className="payment-option-container">
        <div className="payment-option-list">
        {Object.keys(availablePaymentOptions).map(key => {
            const paymentOption = availablePaymentOptions[key]
            return (
                <label className="payment-option" key={key}>
                    <input required className="payment-option-input radio-input radio-input--red" type="radio" title={paymentOption.title} name="paymentOption" checked={key===props.paymentOption.value} value={key} 
                        onChange={(e) => props.onChange({value: e.target.value})} 
                    />
                    <span className="payment-option-title">{paymentOption.title}</span>
                </label>
            )
        })}
        </div>
        {selectedPaymentOption && selectedPaymentOption.render && (
        <div className="payment-option-parameter">
            {selectedPaymentOption.render(props)}
        </div>
        )}
    </div>
}


// WEBPACK FOOTER //
// ./src/components/PaymentOptions.jsx